import styled from 'styled-components'

export const ContainerComments = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  flex-direction: column;
  padding-left: 40px;
  padding-top: 25px;
  div {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding-top: 15px;
    padding-bottom: 15px;
    color: ${({ theme }) => theme.colors.lightGray};
    label {
      color: ${({ theme }) => theme.colors.gray};
    }
  }
`
